<template>
    <!-- 音频说法 -->
  <div id="audioclaim">
      
    <section> <audclbanner /> </section>

    <section class="w_10f8"> <audclcont /> </section>
    
  </div>
</template>

<script>
import audclbanner from './child/audclbanner'//音频说法轮播及菜单
import audclcont from './child/audclcont'//音频说法正文部分

export default {
  name: "audioclaim",
  components: {

    // 私
    audclbanner,
    audclcont,
  },

}
</script>

<style lang="scss" scoped>
#audioclaim {
  background-color: #fff;
  .audionav{
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  }
  .w_10f8{
      width: 100%;
      background-color:#F8F8F8 ;
  }
}
</style>
